import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import { FaLock } from "react-icons/fa";

const RunQCKitPreparation = ({
  kitData,
  getStudyKitPreparationData,
  Show,
  Hide,
  Title,
  setKitId,
  eiwrsPermission
}) => {
  const { studyId } = useParams()
  const [status, setStatus] = useState("");
  const [QCComment, setQCComment] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [QCChecklist, setQCChecklist] = useState({
    labelVerification: false,
    kitContentVerification: false,
    batchLotVerification: false,
    expiryVerification: false,
    tamperSealVerification: false,
    barcodeScanVerification: false,
  });
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const handleChecklistChange = (key) => {
    setQCChecklist((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const statusConvertKitPreparation = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Run QC Kit!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, run it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitData?._id;
        userData.studyId = studyId;
        userData.status = status;
        userData.QCComment = QCComment;
        userData.QCChecklist = QCChecklist;
        userData.mode = StudyMode;
        let data = await eiwrsKitPreparationServices.statusConvertKitPreparation(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyKitPreparationData();
          Hide();
          setStatus("");
          setQCComment("");
        }
      }
      setButtonLoader(false);
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="mb-3">
            <Card.Body className="p-3">
              <Row>
                {kitData?.kitNumber &&
                  <Col xs={6}>
                    <div className="text-muted small">Kit Number</div>
                    <Form.Label>{kitData?.kitNumber}</Form.Label>
                  </Col>
                }
                {kitData?.kitType &&
                  <Col xs={6}>
                    <div className="text-muted small">Kit Type</div>
                    <Form.Label className="text-capitalize">{kitData?.kitType} Kit</Form.Label>
                  </Col>
                }
                {kitData?.siteName &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Depot-Site</div>
                    <Form.Label>{kitData?.depot}-{kitData?.siteName}</Form.Label>
                  </Col>
                }
                {kitData?.batchNumber &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Batch Number</div>
                    <Form.Label>{kitData?.batchNumber}</Form.Label>
                  </Col>
                }
                {kitData?.treatment &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Treatment</div>
                    <Form.Label>
                      {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation || eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                        kitData?.treatment
                        :
                        <Badge style={{ width: 70 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                      }
                    </Form.Label>
                  </Col>
                }
                {kitData?.expiryDate &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Expiry Date</div>
                    <Form.Label>{kitData?.expiryDate}</Form.Label>
                  </Col>
                }
              </Row>
            </Card.Body>
          </Card>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold text-uppercase">
              QC Checklist
            </Form.Label>

            <Form.Check
              type="checkbox"
              label="Label verification"
              checked={QCChecklist.labelVerification}
              onChange={() => handleChecklistChange("labelVerification")}
            />

            <Form.Check
              type="checkbox"
              label="Kit content verification"
              checked={QCChecklist.kitContentVerification}
              onChange={() => handleChecklistChange("kitContentVerification")}
            />

            <Form.Check
              type="checkbox"
              label="Batch & lot verification"
              checked={QCChecklist.batchLotVerification}
              onChange={() => handleChecklistChange("batchLotVerification")}
            />

            <Form.Check
              type="checkbox"
              label="Expiry verification"
              checked={QCChecklist.expiryVerification}
              onChange={() => handleChecklistChange("expiryVerification")}
            />

            <Form.Check
              type="checkbox"
              label="Tamper seal verification"
              checked={QCChecklist.tamperSealVerification}
              onChange={() => handleChecklistChange("tamperSealVerification")}
            />

            <Form.Check
              type="checkbox"
              label="Barcode scan verification"
              checked={QCChecklist.barcodeScanVerification}
              onChange={() => handleChecklistChange("barcodeScanVerification")}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              QC Result <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">
                Select QC Result
              </option>
              <option value="passedQC">Passed</option>
              <option value="failedQC">Failed</option>
              <option value="rework">Rework</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              QC Comment
            </Form.Label>
            <Form.Control
              onChange={(e) => setQCComment(e.target.value)}
              value={QCComment}
              className="br3"
              placeholder="Enter Comment"
              as="textarea"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!status || buttonLoader}
            className="updateProfile"
            onClick={(e) => statusConvertKitPreparation(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Runing...
              </div>
            ) : (
              "Run QC"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default RunQCKitPreparation;
